var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgObstacleMonster21X1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svg/obstacleMonster2-1x1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "obstacleMonster2-1x1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#BB3584",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Monster_2",
    transform: "translate(-20.000000, -13.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#BB3584",
    cx: 33.5,
    cy: 30,
    rx: 21.5,
    ry: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(12.000000, 10.000000)",
    fill: "#BB3584"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    cx: 20.5214575,
    cy: 19.1794872,
    rx: 20.5214575,
    ry: 18.5641026
  })), /*#__PURE__*/React.createElement("g", {
    id: "Virus_3",
    transform: "translate(9.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2296563,19.4373626 C29.9783961,18.567033 32.4974141,17.5309262 34.4959738,17.4480377",
    id: "STROKE_04746673-b224-4a39-a896-7272213663c6",
    stroke: "#000000",
    strokeWidth: 1.10769231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1959411,17.6759812 C19.7982324,17.4687598 22.0882488,18.8571429 24.3990835,19.7896389",
    id: "STROKE_9080ef33-28e4-4f0b-af3a-4c2c4952fe17",
    stroke: "#000000",
    strokeWidth: 1.10769231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Left-eye",
    transform: "translate(15.621315, 20.248939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.735412,5.28073161 C10.4640536,-2.36573621 -1.40239487,-1.30890732 0.138161593,5.88167352 C0.991713148,9.92248985 9.17331708,9.28010367 9.735412,5.28073161 Z",
    id: "STROKE_e3037c9f-e4b1-4e83-a6ba-f3b8bed8a3a5",
    stroke: "#000000",
    strokeWidth: 1.10769231,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.48991282,4.43112407 C3.44827616,4.45184621 3.36500284,4.49329048 3.30254784,4.55545688 C3.11518287,4.7419561 3.15681953,5.03206599 3.15681953,5.07351026 C3.17763786,5.38434228 3.30254784,5.55011936 3.44827616,5.61228577 C3.73973279,5.73661858 4.23937272,5.34289801 4.23937272,4.90773318 C4.23937272,4.67978969 4.09364441,4.51401261 4.03118942,4.45184621 C3.84382444,4.34823553 3.73973279,4.30679126 3.48991282,4.43112407 Z",
    id: "STROKE_100e0c68-45c6-47b1-91ea-08498de673f2",
    stroke: "#000000",
    strokeWidth: 1.10769231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28100938,3.64368294 C5.09292428,3.62296081 5.09292428,4.90773318 4.28100938,4.88701104 C3.46909449,4.90773318 3.46909449,3.64368294 4.28100938,3.64368294 Z",
    id: "STROKE_8e5e0530-8c72-4963-9486-ca1ed27e0171",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Right-eye",
    transform: "translate(28.099450, 20.287464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66572162,3.10782612 C7.58316843,-0.518547508 3.54441229,-0.684324588 1.40012424,1.13922329 C-0.20288722,2.5068842 -0.473525518,5.32509456 0.81721098,7.02430964 C2.52431409,9.28302235 7.4998951,8.99291246 8.56162996,6.15397996 C8.89472325,5.20076175 8.91554159,3.95743365 8.66572162,3.10782612",
    id: "STROKE_c1de529b-9b80-4009-8620-7952ccb96b87",
    stroke: "#000000",
    strokeWidth: 1.10769231,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50277563,4.86920759 C2.89904404,4.47548703 2.35776744,5.28365029 3.00313569,5.63592659 C3.27377399,5.7602594 3.71095893,5.69809299 3.77341393,5.26292816 C3.79423226,5.05570681 3.66932227,4.97281827 3.50277563,4.86920759",
    id: "STROKE_dcda3163-2e51-4df1-ae65-a2c54a81e7b4",
    stroke: "#000000",
    strokeWidth: 1.10769231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.89832391,3.97815579 C4.7102388,3.95743365 4.7102388,5.24220602 3.89832391,5.22148389 C3.08640902,5.24220602 3.08640902,3.97815579 3.89832391,3.97815579 Z",
    id: "STROKE_627d2b4c-6c09-4e2e-bc08-98ea755b4937",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mouth",
    transform: "translate(15.613748, 31.668760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.027234,0.74599686 C14.1148282,-0.33155416 7.78605565,2.77555756e-17 1.81119476,0.87032967 C-0.728641571,1.47127159 0.0832733224,4.144427 0.916006547,5.8021978 C6.93250409,5.90580848 13.2196399,6.07158556 19.1736825,5.20125589 C20.8183306,4.68320251 20.5476923,2.05149137 20.027234,0.74599686",
    id: "STROKE_f156c8ef-04f0-4760-9bd0-8254e2299538_1_",
    fill: "#2D4060",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8240917,5.96797488 C12.8657283,6.03014129 8.26487725,6.09230769 8.26487725,6.09230769 C8.26487725,6.09230769 9.97198036,2.77676609 10.200982,2.63171115 C10.4299836,2.4866562 12.782455,5.92653061 12.8240917,5.96797488 Z M7.86932897,0.4144427 C7.91096563,0.66310832 6.20386252,3.46059655 5.5793126,3.70926217 C4.87148936,3.17048666 3.8097545,0.8288854 3.8097545,0.8288854 C3.8097545,0.8288854 7.20314239,0.49733124 7.86932897,0.4144427 Z M13.6360065,0.33155416 C14.2397381,0.29010989 17.8621277,0.683830455 17.8621277,0.683830455 C17.8621277,0.683830455 15.5929296,3.58492936 15.3847463,3.50204082 C15.2098723,3.43241444 14.0948759,1.24266499 13.7425538,0.543727603 Z",
    id: "Combined-Shape-Copy",
    stroke: "#000000",
    strokeWidth: 0.738461538,
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "teeth",
    transform: "translate(3.747300, 0.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.07679214,5.76075353 C9.11842881,5.82291994 4.51757774,5.88508634 4.51757774,5.88508634 C4.51757774,5.88508634 6.22468085,2.56954474 6.45368249,2.4244898 C6.68268412,2.27943485 9.03515548,5.71930926 9.07679214,5.76075353 Z M4.12202946,0.20722135 C4.16366612,0.45588697 2.45656301,3.2533752 1.83201309,3.50204082 C1.12418985,2.96326531 0.0624549918,0.62166405 0.0624549918,0.62166405 C0.0624549918,0.62166405 3.45584288,0.29010989 4.12202946,0.20722135 Z M9.88870704,0.12433281 C10.4924386,0.08288854 14.1148282,0.476609105 14.1148282,0.476609105 C14.1148282,0.476609105 11.8456301,3.37770801 11.6374468,3.29481947 C11.4625728,3.22519309 10.3475764,1.03544364 9.99525425,0.336506253 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.027234,0.74599686 C14.1148282,-0.33155416 7.78605565,2.77555756e-17 1.81119476,0.87032967 C-0.728641571,1.47127159 0.0832733224,4.144427 0.916006547,5.8021978 C6.93250409,5.90580848 13.2196399,6.07158556 19.1736825,5.20125589 C20.8183306,4.68320251 20.5476923,2.05149137 20.027234,0.74599686",
    id: "STROKE_f156c8ef-04f0-4760-9bd0-8254e2299538_2_",
    stroke: "#000000",
    strokeWidth: 1.10769231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#222222",
    strokeWidth: 0.03,
    x: 0.015,
    y: 0.015,
    width: 29.97,
    height: 29.97
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObstacleMonster21X1);
export default __webpack_public_path__ + "static/media/obstacleMonster2-1x1.e202199ee6aab4cf4ea21c8015da2e69.svg";
export { ForwardRef as ReactComponent };